/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:55
 */
import Column from "./Column";

class SortColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

}

export default SortColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/columns/SortColumn.js